import React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Box,
  Avatar,
} from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { ButtonPrimary } from "../../../../components/button/ButtonCustoms";

interface ClassroomCardProps {
  room: any;
  formMeetingRoom: Record<string, any>; // Adjust based on actual structure
  setFormMeetingRoom: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  setIsModalRoomDetail: React.Dispatch<React.SetStateAction<boolean>>;
}

const ClassroomCard: React.FC<ClassroomCardProps> = ({
  room,
  formMeetingRoom,
  setFormMeetingRoom,
  setIsModalRoomDetail,
}) => {
  return (
    <Card className="h-full rounded-lg overflow-hidden shadow-md">
      <Box className="relative">
        <CardMedia
          component="img"
          className="w-full h-64 object-cover"
          image={
            room?.files?.find(
              (item: any) => item.room_meeting_file_type === "COVER"
            )
              ? `${process.env.REACT_APP_FILE_BASE_API}/${
                  room.files.find(
                    (item: any) => item.room_meeting_file_type === "COVER"
                  ).file_path
                }`
              : ""
          }
          alt="Room Cover Image"
        />
        <Box className="absolute top-2 right-2 bg-white rounded-full p-1">
          <RemoveRedEyeIcon
            onClick={() => {
              setIsModalRoomDetail(true);
            }}
          />
        </Box>
      </Box>

      <CardContent className="p-4">
        <Typography variant="h6" className="font-bold text-gray-800">
          {room.room_meeting_type} {room.room_meeting_name}
        </Typography>

        <Box className="flex items-center justify-between mt-2">
          {/* Location */}
          <Box className="flex items-center overflow-hidden">
            <FmdGoodIcon className="mr-1" />
            <Typography variant="body2" className="text-gray-500 truncate w-40">
              {room.room_meeting_location}
            </Typography>
          </Box>

          {/* Meeting Amount */}
          <Box className="flex items-center overflow-hidden">
            <AccountCircleIcon className="mr-1" />
            <Typography variant="body2" className="text-gray-500 truncate w-20">
              {room.room_meeting_amount} คน
            </Typography>
          </Box>
        </Box>

        <section className="col-span-12 flex items-center justify-center mt-4">
          <ButtonPrimary
            onClick={() =>
              setFormMeetingRoom((prev) => ({
                ...prev,
                id_room_meeting:
                  prev.id_room_meeting === room.id_room_meeting
                    ? 0
                    : room.id_room_meeting,
              }))
            }
            disabled={
              formMeetingRoom.id_room_meeting > 0 &&
              formMeetingRoom.id_room_meeting !== room.id_room_meeting
            }
            mode={
              formMeetingRoom.id_room_meeting === room.id_room_meeting
                ? "del"
                : "next"
            }
            buttonName={
              formMeetingRoom.id_room_meeting === room.id_room_meeting
                ? "ยกเลิก"
                : "เลือก"
            }
            btnProps={{ width: "100%" }}
          />
        </section>
      </CardContent>
    </Card>
  );
};

export default ClassroomCard;
